import Wrapper from '../../assets/wrappers/Loading'

const Loading = () => {
  return (
    <Wrapper>
      <div className="loading"></div>
    </Wrapper>
  )
}
export default Loading
